import React, {
  useContext,
  useState,
  useEffect,
  FC,
  Dispatch,
  SetStateAction,
  ChangeEvent
} from 'react';

import AnimatedNumber from 'react-animated-number';

import { GlobalContext } from '../../../../store';
import { IAdminGroup } from '../../../../store/admin/groups/store';
import { IAdminMembership } from '../../../../store/admin/memberships/store';

import Input from '../../../../components/Input';
import PlayerList from '../../EventWizard/PlayerList/PlayerList';
import { ClubPlayerRosterStyled } from './ClubPlayerRoster.Styles';

interface IProps {
  selectedMembers: IAdminMembership[];
  setSelectedMembers: Dispatch<SetStateAction<IAdminMembership[]>>;
}

const ClubPlayerRoster: FC<IProps> = props => {
  const { setSelectedMembers, selectedMembers } = props;

  const { adminGroups: groups, adminMemberships } = useContext(GlobalContext);

  const [playerSearch, setPlayerSearch] = useState<string>();
  const [selectedGroups, setSelectedGroups] = useState<number[]>([]);
  const [memberships, setMemberships] = useState<IAdminMembership[]>([]);

  useEffect(() => {
    if (adminMemberships.memberships.length > 0) {
      setMemberships(adminMemberships.memberships);
    }
  }, [adminMemberships]);

  const memberSelection = (member: IAdminMembership) => {
    let newSelectedMembers = [...selectedMembers];

    if (Boolean(newSelectedMembers.find((item: IAdminMembership) => item.id === member.id))) {
      member.groups.forEach((tag: IAdminGroup) => {
        if (selectedGroups.includes(tag.id)) {
          const idx = selectedGroups.indexOf(tag.id);
          selectedGroups.splice(idx, 1);
        }
      });

      newSelectedMembers = newSelectedMembers.filter(
        (item: IAdminMembership) =>
          item.id !== member.id || member.groups.some((g: any) => selectedGroups.includes(g.id))
      );
    } else {
      newSelectedMembers.push(member);
    }

    newSelectedMembers = newSelectedMembers.filter((v, i) => newSelectedMembers.indexOf(v) === i);

    setSelectedMembers(newSelectedMembers);
    setSelectedGroups(selectedGroups);
  };

  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setPlayerSearch(event.target.value);
  };

  return (
    <ClubPlayerRosterStyled>
      <div className="titles-row">
        <div className="lookup">
          <Input
            label="PLAYER LOOKUP"
            id="playerfield-lookup"
            type="search"
            onChange={onSearch}
            outlined={true}
            placeholder="FIND A PLAYER"
          />
        </div>

        <div className="total-label">TOTAL</div>

        <div className="total-value">
          <AnimatedNumber
            component="div"
            stepPrecision={0}
            value={selectedMembers.length}
            style={{
              transition: '0.8s ease-out',
              transitionProperty: 'background-color, color, opacity'
            }}
            duration={300}
          />
        </div>
      </div>

      <PlayerList
        members={memberships}
        invited={[]}
        selectedMembers={selectedMembers}
        memberSelection={memberSelection}
        search={playerSearch}
        groupEdition={true}
        groups={groups.groups || []}
      />
    </ClubPlayerRosterStyled>
  );
};

export default ClubPlayerRoster;
